import React from 'react';
import ErrorMainPage from './error.page';
import { injectIntl } from 'react-intl';

function ErrorMainContainer({ intl, match }) {
    const { messages } = intl;

    let title = messages['pages.error.notfoundpage'];
    let desc = messages['pages.error.notfoundpagedesc'];
    let code = 404;
    let origin = '';

    try {
      title = atob(match.params.title);
      desc = atob(match.params.desc);
      code = atob(match.params.code);
      origin = atob(match.params.origin);
    } catch (error) {}
    return (
      <ErrorMainPage title={title} desc={desc} code={code} origin={origin} />
    );
  }

export default injectIntl(ErrorMainContainer);



// WEBPACK FOOTER //
// ./src/pages/error/error.container.js